import React from 'react';
import InfoToDoListView from './InfoToDoListView';

/**
 *  InfoToDoList
 * @param {*} props props
 * @return {JSX}
 */
function InfoToDoList(props) {
  return (
    <div>
      <InfoToDoListView
        closeModal={props.closeModal}
        todolist={props.todolist}
      />
    </div>
  );
}

export default InfoToDoList;
